import React, { useState } from 'react'
import toast from 'react-hot-toast';
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import './Register.css'
const Register = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [address, setAddress] = useState("");
    const [question, setQuestion
    ] = useState("");
    const navigate = useNavigate();
    const [focused, setFocused] = useState(false);
    const handleFocus = (e) => {
        setFocused(true);
    };
    //form section    
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post("https://bablu-server.onrender.com/auth/register", {
                name,
                email,
                password,
                phone,
                address,
                question,
            });
            if (res && res.data.success) {
                toast.success(res.data.message);
                navigate("/login");
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    return (
        <Layout>
            <div className="form_container mt-5">
                <form onSubmit={handleSubmit}>
                <h4 className='text-center mt-3'>Register</h4>
                    <div className="formInput">
                    <div className="mb-3 form_input">
                        <label className="form-label">Name</label>
                        <input type="text" className="form-control" id="exampleInputName1" placeholder='Enter your Name' value={name} onChange={(e) => setName(e.target.value)}
                            onBlur={handleFocus}
                            onFocus={() => name === setFocused(true)}
                            focused={focused.toString()} />
                        <span>  "Username should be 3-16 characters and shouldn't include any special character!"</span>
                    </div>
                    <div className="mb-3 form_input">
                        <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder='Enter your Email' value={email} onChange={(e) => setEmail(e.target.value)} onBlur={handleFocus}
                            onFocus={() => name === setFocused(true)}
                            focused={focused.toString()} />
                        <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                    </div>
                    <div className="mb-3 form_input">
                        <label className="form-label">Phone</label>
                        <input type="text" className="form-control" id="exampleInputphone1" placeholder='Enter your Mobile no ' value={phone} onChange={(e) => setPhone(e.target.value)} onBlur={handleFocus}
                            onFocus={() => name === setFocused(true)}
                            focused={focused.toString()} pattern="^[0-9]{10}$" />
                        <span>Mobile no should be 10digit or no any character..</span>
                    </div>
                    <div className="mb-3 form_input">
                        <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" placeholder='Enter password' value={password} onChange={(e) => setPassword(e.target.value)} onBlur={handleFocus}
                            onFocus={() => name === setFocused(true)}
                            focused={focused.toString()} pattern="^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$" />
                        <span>Password must contain 1 Capital, 1 Small letter, 1number and 1 special character.</span>
                    </div>
                    <div className="mb-3 form_input">
                        <label htmlFor="exampleInputPassword1" className="form-label">Question</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" placeholder='Enter your Question...' value={question} onChange={(e) => setQuestion(e.target.value)} onBlur={handleFocus}
                            onFocus={() => name === setFocused(true)}
                            focused={focused.toString()}  />
                        <span>Question should be greater than 7</span>
                    </div>
                    <div className="mb-3 form_input">
                        <label className="form-label">Address</label>
                        <input type="text" className="form-control" id="exampleInputAddress1" placeholder='Enter Address' value={address} onChange={(e) => setAddress(e.target.value)} onBlur={handleFocus}
                            onFocus={() => name === setFocused(true)}
                            focused={focused.toString()} pattern="^[A-Za-z0-9]{10,100}$\s]" required />
                        <span>Address must be 10 character...</span>
                    </div>
                    <button type="submit" className="form_button">Submit</button>
                    </div>
                </form>
                {/* const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log(name, email, phone, password, address);
        // toast.success("Register SuccessFull.")
        try {
            const res = await axios.post("https://bablu-server.onrender.com/auth/register", { name, email, phone, password, address });
            if (res && res.data.success) {
                toast.success(res.data && res.data.message);
                navigate('/');

            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong!");
        }
    } */}
            </div>
        </Layout>
    )
}

export default Register